import { Seo } from '../components/Seo';

const Privacy = () => (
  <>
    <Seo
      title="Privacy · Prepzio"
      description="How Prepzio handles your email, practice data, and analytics during the private beta."
      path="/privacy"
    />
    <main className="section">
      <div className="container-narrow legal">
        <p className="eyebrow">Privacy</p>
        <h1>Privacy notice</h1>
        <p className="legal__date">Last updated · June 2026</p>

        <p>
          This page describes what Prepzio collects, why, and what you can do about it. Plain
          English. No dark patterns. If anything here is unclear, email{' '}
          <a href="mailto:hello@prepzio.io">hello@prepzio.io</a>.
        </p>

        <h2>1. What we collect</h2>
        <ul>
          <li>
            <strong>Waitlist email.</strong> The address you submit on this site so we can invite
            you to the private beta.
          </li>
          <li>
            <strong>UTM &amp; referrer (optional).</strong> If you arrive via a tracked link, the
            source helps us understand which channels work. Never used to build advertising
            profiles.
          </li>
          <li>
            <strong>Country code.</strong> Cloudflare attaches a country code to each request. We
            store it once at sign-up for capacity planning.
          </li>
          <li>
            <strong>App practice data (later).</strong> Inside the mobile app we will store your
            answers, hint usage, and rubric scores to compute progress. None of this is sold or
            shared.
          </li>
        </ul>

        <h2>2. What we do not do</h2>
        <ul>
          <li>No third-party ad networks. No remarketing pixels.</li>
          <li>No selling or renting of email lists. Ever.</li>
          <li>No tracking cookies on this marketing site.</li>
        </ul>

        <h2>3. Email use</h2>
        <p>
          Your waitlist email receives at most one product update per month plus the beta invite
          when your batch opens. Every email has a one-click unsubscribe link.
        </p>

        <h2>4. Deleting your data</h2>
        <p>
          Send a request to <a href="mailto:hello@prepzio.io">hello@prepzio.io</a> and we will
          remove your email and any associated records within seven days.
        </p>

        <h2>5. Children</h2>
        <p>
          Prepzio is not directed at people under 16. Please do not sign up if you are below that
          age.
        </p>

        <h2>6. Changes</h2>
        <p>
          When this notice changes meaningfully, the date at the top is updated and we email anyone
          on the waitlist before the change takes effect.
        </p>
      </div>
    </main>
  </>
);

export default Privacy;
